import React from "react";
import "./OwnerAvatar.scss";

/** Badge photo for an alias (internal directory image). */
export const avatarUrl = (alias: string) =>
  `https://badgephotos.corp.amazon.com/?uid=${encodeURIComponent(alias)}`;

/**
 * Round badge photo of a user. Badge photos are portrait; an SVG `<image>` with `slice` crops
 * them to the square (like object-fit: cover) instead of squashing them.
 */
export const UserAvatar: React.FC<{ alias: string; className?: string }> = ({
  alias,
  className = "lusca-user-avatar",
}) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    aria-hidden="true"
    focusable="false"
  >
    <image
      href={avatarUrl(alias)}
      width="16"
      height="16"
      preserveAspectRatio="xMidYMin slice"
    />
  </svg>
);
